import React from 'react';

import { DescriptiveTags } from '@r6digital/rapidstor-types/types/Descriptor';

import {
    faBicycle,
    faBox,
    faClock,
    faHouse,
    faUser,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import classes from './styles.module.scss';

interface Props {
    tags: DescriptiveTags[];
    secondary?: boolean;
    tertiary?: boolean;
    wizard?: boolean;
}

export default function DescriptorTag({ tags, secondary, tertiary, wizard }: Props) {
    const iconNames = ['house', 'bicycle', 'clock', 'image-user', 'box'];
    const icons = [faHouse, faBicycle, faClock, faUser, faBox];

    const getIcon = (name: string) => {
        const index = iconNames.findIndex((el) => el === name);
        return icons[index];
    };

    return (
        <div
            className={`${wizard && classes.wizard} ${classes.tags} ${
                secondary
                    ? classes.secondary
                    : tertiary
                    ? classes.tertiary
                    : classes.primary
            }`}
        >
            {tags &&
                tags.map((tag, index) => {
                    if (tag.enabled) {
                        return (
                            <div key={`${tag.icon}_${index}_idx`} id={`${tag.icon}`}>
                                <FontAwesomeIcon size='lg' icon={getIcon(tag.icon)} />
                                <span>{tag.content}</span>
                            </div>
                        );
                    }
                })}
        </div>
    );
}
